import { render } from "./socialApp.vue?vue&type=template&id=5ec0f46c"
import script from "./socialApp.vue?vue&type=script&lang=js"
export * from "./socialApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__